var jade = require("/home/circleci/rentapplication-frontend/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<img" + (jade.attr("src", require('./../tip-lightbulb-copy-3.svg'), true, true)) + " width=\"55\" alt=\"\"><div style=\"width:240px;\"><h3>Here's your first form! Click \"View\" to preview or \"Edit\" to make changes to your form.</h3></div><div class=\"dots\"><a href=\"#\" class=\"dot dot1-button active\"></a><a href=\"#\" onClick=\"window.Shepherd.activeTour.show('form-step2')\" class=\"dot dot2-button\"></a><a href=\"#\" onClick=\"window.Shepherd.activeTour.show('form-step3')\" class=\"dot dot3-button\"></a></div>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./components/dashboard/forms/tour/first_form/step1.jade
// module id = 733
// module chunks = 0